<template>
  <div>
    <div class="mt-goods-top">
      <div class="mt-goods-img">
        <img :src="imgServer+'logo.png'" alt="" />
      </div>
      <div class="mt-goods-single" style="margin-top: 15px;">
        <div class="mt-goods-name">{ {{orderStatusTxt}} } -- {{useStatusTxt}}</div>
        <div class="mt-goods-id">订单号：{{detailInfo.orderNo}}</div>
      </div>
      <div class="mt-goods-content">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="订单信息" name="orderInfo">
            <div class="mt-order-box">
              <div class="mt-order-title flex-row-align">
                <div class="bg-theme"></div> 用户信息
              </div>
              <div class="flex-row-align">
                <div class="mt-order-row">
                  用户ID：{{detailInfo.userId}}
                </div>
                <div class="mt-order-row">
                  用户昵称：{{detailInfo.nickName}}
                </div>
                <div class="mt-order-row">
                  绑定手机：{{detailInfo.phone}}
                </div>
              </div>
            </div>
            <div class="mt-order-box">
              <div class="mt-order-title flex-row-align">
                <div class="bg-theme"></div> 商品信息
              </div>
              <div class="mt-order-table">
                <el-table
                    :data="goodsList"
                    border
                    style="width: 100%">
                    <el-table-column
                      prop="thumb"
                      label="商品图片"
                      width="180">
                      <template slot-scope="scope">
                        <el-image
                          style="width: 40px;"
                          :src="scope.row.thumb"
                          :preview-src-list="[scope.row.thumb]"
                          fit="contain"></el-image>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="cardName"
                      label="商品名称"
                      width="180">
                    </el-table-column>
                    <el-table-column
                      prop="buyNumber"
                      label="商品数量">
                    </el-table-column>
                  </el-table>
              </div>
            </div>
            <div class="mt-order-box">
              <div class="mt-order-title flex-row-align">
                <div class="bg-theme"></div> 订单信息
              </div>
              <div class="flex-row-align">
                <div class="mt-order-row">
                  创建时间：{{detailInfo.createTime}}
                </div>
                <div class="mt-order-row">
                  商品总数：{{detailInfo.buyNumber}}
                </div>
                <div class="mt-order-row">
                  商品总价：{{detailInfo.orderMoney}}
                </div>
                <div class="mt-order-row">
                  支付金额：{{detailInfo.realPayMoney}}
                </div>
                <div class="mt-order-row">
                  支付方式：{{detailInfo.payTypeText}}
                </div>
              </div>
            </div>
            <div class="mt-order-box">
              <div class="mt-order-title flex-row-align">
                <div class="bg-theme"></div> 使用信息
              </div>
              <div class="mt-order-table">
                <el-table
                    :data="detailInfo.cardMinePageVoList"
                    border
                    style="width: 100%">
                    <el-table-column
                      prop="cardPassword"
                      label="卡密"
                      width="180">
                    </el-table-column>
                    <el-table-column
                      prop="useStatus"
                      label="是否使用">
                      <template slot-scope="scope">
                        <span v-if="scope.row.useStatus == 1" class="color-theme">已使用</span>
                        <span v-else>未使用</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="useNickName"
                      label="使用用户">
                    </el-table-column>
                    <el-table-column
                      prop="usePhone"
                      label="充值账户">
                    </el-table-column>
                    <el-table-column
                      prop="useDateTime"
                      label="使用时间">
                    </el-table-column>
                  </el-table>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchGiftCardOrderDetail } from '@/api/giftCard'
export default {
  name: 'GiftCardOrderDetail',
  props: {
    infoId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      fullscreenLoading: false,
      activeName: 'orderInfo',
      detailInfo: {
        thumb: '',
        orderType: '',
        useStatus:'',
        orderNo:'',
        userId: '',
        phone: '',
        nickName: '',
        phone: '',
        cardMinePageVoList: [],
        createTime: '',
        buyNumber: '',
        orderMoney: '',
        realPayMoney: '',
        discountMoney: '',
        payTypeText: '',
        payType:''
      },
      orderStatusTxt:'',
      useStatusTxt:'',
      goodsList:[],
      // 订单改价弹窗
      changePriceShow:false,
      changePriceForm:{
        price:''
      }
    }
  },
  mounted () {
    this.detailInfoFun();
  },
  methods: {
    /* 切换选项卡操作 */
    handleClick (tab) {},
    detailInfoFun(){
      var that = this;
      console.log(that.infoId,'that.infoId');
      fetchGiftCardOrderDetail({orderId:that.infoId}).then((res) => {
        if (res.errorCode === '0000') {
          var data = res.data;
          var useStatusTxt = '';
          switch (data.useStatus) {
            case 0:
              useStatusTxt = '待使用';
              break;
            case 1:
              useStatusTxt = '已使用';
              break;
          }
          var orderStatusTxt = '';
          switch (data.orderType) {
            case 1:
              orderStatusTxt = '商城订单';
              break;
            case 2:
              orderStatusTxt = '礼品卡订单';
              break;
            case 3:
              orderStatusTxt = '体验店订单';
              break;
          }
          var goodsList = [{
            thumb:data.thumb,
            cardName:data.cardName,
            buyNumber:data.buyNumber
          }]
          that.orderStatusTxt = orderStatusTxt;
          that.useStatusTxt = useStatusTxt;
          that.goodsList = goodsList;
          that.detailInfo = data;
        }
      });
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/giftCard/components/GiftCardOrderDetail.vue